import useFormatMessage from "./useFormatMessage";

const useYesNo = () => {
  const f = useFormatMessage();

  return (value?: boolean) => (value ? f("default.yes") : f("default.no"));
};

export default useYesNo;
